/* Rockabye motion: scroll-reveal (slide up + fade, staggered) for cards and headings.
   Content is only hidden once this script has run, so nothing disappears without JS.
   Respects prefers-reduced-motion. Re-scans when sections reload in the theme editor. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = [
    '.rb-head', '.rb .rb-toy', '.rb-theme', '.rb-trust li', '.rb-bs__tabs', '.rb-bs__intro',
    '.rb-promo__panel', '.rb-fcontact__item', '.rb-sr__grid > *', '.rb-faq details',
    '.section-heading-container .section-heading-elements', '.product-card',
    '.brands-grid img', '.rb-showroom .rb-wrap > *'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    var n = 0;
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.style.setProperty('--rb-d', Math.min(n, 6) * 90 + 'ms');
      el.classList.add('is-in');
      n++;
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.12 });

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.classList.contains('rb-rv') || el.closest('.rb-hero, .rb-cats, header, .drawer, .modal, predictive-search, .cart-drawer')) return;
      var r = el.getBoundingClientRect();
      el.classList.add('rb-rv');
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  document.documentElement.classList.add('rb-motion');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  // Safety net: reveal anything still hidden after 6s (e.g. inside a carousel that never scrolls into view).
  setTimeout(function () { document.querySelectorAll('.rb-rv:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 6000);
})();
